import BaseComponent from "../../../../base/base_component";
import { CONTAINER_IDS, DEFAULT_SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL } from './last_login_consts';
import {SYSTEM_EVENTS} from "../../../../events/events";
import DOM, {TimeoutSubscription} from "../../../../utils/dom";
import LastLoginComponentController from './last_login_component_controller';
import SessionTimerController from '../../../session_timer/session_timer_controller';
import { BaseComponentParams } from '../../../../base/base_component_interface';

const view = require('./view/last_login_composite.html');

interface LastLoginCompositeInitParams extends BaseComponentParams {
  lastLoginComponent: LastLoginComponentController;
  sessionTimerComponent: SessionTimerController;
  switchToSessionTimerWaitInterval?: number;
}

export default class LastLoginCompositeController extends BaseComponent {
  static CLASS: string = 'LastLoginCompositeController';
  private _switchToSessionTimerWaitInterval: number;
  private _lastLoginComponent: LastLoginComponentController = null;
  private _sessionTimerComponent: SessionTimerController = null;

  init(params: LastLoginCompositeInitParams) {
    super.init(params);
    this._lastLoginComponent = params.lastLoginComponent;
    this._sessionTimerComponent = params.sessionTimerComponent;
    this._switchToSessionTimerWaitInterval = params.switchToSessionTimerWaitInterval ? params.switchToSessionTimerWaitInterval : DEFAULT_SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL;
  }

  start() {
    const bakedHTML = this.bake(view);
    this.setHTML(bakedHTML);
    this._subscribe();

    if (this._lastLoginComponent) {
      this._lastLoginComponent.start();
      this.appendChildComponent(this._lastLoginComponent, CONTAINER_IDS.LAST_LOGIN);
    }

    if (this._sessionTimerComponent) {
      this._sessionTimerComponent.start();
      this.appendChildComponent(this._sessionTimerComponent, CONTAINER_IDS.SESSION_TIMER);
    }

    if (this.serviceFactory.oAuth2Service().isAuthorized()) {
      this._onLogin();
    }

    return this;
  }


  private _subscribe(): void {
    this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
      this.serviceFactory.oAuth2Service().isAuthorized() ? this._onLogin() : this._onLogout();
    });
  }


  private _switchToSessionTimerSubscription: TimeoutSubscription = null;
  private _onLogin(): void {
    DOM.show(this.querySelector(CONTAINER_IDS.LAST_LOGIN));

    this._switchToSessionTimerSubscription = this.setTimeout(() => {
      DOM.hide(this.querySelector(CONTAINER_IDS.LAST_LOGIN))
          .show(this.querySelector(CONTAINER_IDS.SESSION_TIMER));
    }
    , this._switchToSessionTimerWaitInterval
    , 'SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL')
  }

  private _onLogout(): void {
    if(this._switchToSessionTimerSubscription) {
      this._switchToSessionTimerSubscription.clear();
    }
    DOM.hide(this.querySelector(CONTAINER_IDS.SESSION_TIMER))
      .hide(this.querySelector(CONTAINER_IDS.LAST_LOGIN));
  }
}